import { css } from "@emotion/react";

type Props = {
  title: string;
};

const Chart: React.FC<Props> = ({ title }) => {
  return (
    <div id="chart" css={mainStyle}>
      <div css={contentsWrapper}>
        <div css={upperTitleWrapperStyle}>
          <div css={borderStyle}></div>
          <div css={titleStyle}>{title}</div>
          <div css={borderStyle}></div>
        </div>
        <img
          src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/chart.png"}
          css={chartImgStyle}
        />
      </div>
    </div>
  );
};

const contentsMaxWidth = 750;
const spSize = 768;

const mainStyle = css`
  width: 100%;
`;

const contentsWrapper = css`
  width: 100%;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const upperTitleWrapperStyle = css`
  width: 85%;
  max-width: 1125px;
  display: flex;
  align-items: center;
  padding: 30px;

  @media (max-width: ${spSize}px) {
    padding: 10px 20px;
    padding-bottom: 10px !important;
  }
`;

const borderStyle = css`
  height: 3px;
  background-color: white;
  flex-grow: 1;
`;

const titleStyle = css`
  padding: 0 15px;
  font-family: MyFont;
  font-size: 18px;
  font-weight: 500;
  line-height: 100%;
`;

const chartImgStyle = css`
  width: 85%;
  max-width: ${contentsMaxWidth}px;
  height: auto;
`;

const marginTopStyle = (num: number) => css`
  margin-top: ${num}px;
`;

export default Chart;
